import { Injectable } from '@angular/core';
import { debounceTime, distinctUntilChanged, Observable, Subject } from 'rxjs';
declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class GooglePlacesService {
  location$ = new Subject<any>();
  constructor() {}
  initAutocomplete(inputElement: HTMLInputElement): void {
    const autocomplete = new google.maps.places.Autocomplete(inputElement);

    const placeChanged$ = new Subject<void>();

    autocomplete.addListener('place_changed', () => {
      placeChanged$.next();
    });
    placeChanged$
      .pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(() => {
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          return;
        }
        this.location$.next(place);
      });
  }

  getPlaceObservable(): Observable<any> {
    return this.location$.asObservable();
  }
}
